/* ==========================================================================
   RasCommerce — collection & search results

   Filtering, sorting, column switching and load-more / infinite scroll, all
   driven through Shopify's native filtering plus the Section Rendering API.
   ========================================================================== */
(function () {
  'use strict';

  var RC = (window.RC = window.RC || {});

  function section() {
    return document.querySelector('[data-rc-collection]');
  }

  /* ------------------------------------------------------------ Rendering */

  function setLoading(on) {
    var grid = document.querySelector('[data-rc-grid]');
    if (grid) grid.classList.toggle('is-loading', on);
  }

  function renderFromUrl(url, options) {
    options = options || {};
    var root = section();
    if (!root) return Promise.resolve();

    var sectionId = root.dataset.sectionId;
    setLoading(true);

    var separator = url.indexOf('?') === -1 ? '?' : '&';

    return RC.fetchText(url + separator + 'section_id=' + sectionId)
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');

        // Results
        var freshResults = doc.querySelector('[data-rc-collection-results]');
        var currentResults = document.querySelector('[data-rc-collection-results]');
        if (freshResults && currentResults) {
          currentResults.innerHTML = freshResults.innerHTML;
        }

        // Facet forms (counts and active pills change with every filter)
        doc.querySelectorAll('[data-rc-facets]').forEach(function (fresh) {
          var context = fresh.dataset.context;
          var current = document.querySelector('[data-rc-facets][data-context="' + context + '"]');
          if (current) current.innerHTML = fresh.innerHTML;
        });

        // Result count and sort label
        ['[data-rc-result-count]', '[data-rc-sort-label]'].forEach(function (selector) {
          var fresh = doc.querySelector(selector);
          var current = document.querySelector(selector);
          if (fresh && current) current.innerHTML = fresh.innerHTML;
        });

        var freshSortMenu = doc.querySelector('[data-rc-sort] .dropdown-menu');
        var currentSortMenu = document.querySelector('[data-rc-sort] .dropdown-menu');
        if (freshSortMenu && currentSortMenu) currentSortMenu.innerHTML = freshSortMenu.innerHTML;

        if (!options.skipHistory) {
          window.history.pushState({ rcFilter: true }, '', url);
        }

        document.dispatchEvent(new CustomEvent('rc:collection:rendered'));
        initPriceSliders(document);

        if (options.scroll !== false) {
          var top = document.querySelector('[data-rc-collection]');
          if (top) window.scrollTo({ top: top.offsetTop - 120, behavior: 'smooth' });
        }
      })
      .catch(function () {
        window.location.href = url;
      })
      .finally(function () {
        setLoading(false);
      });
  }

  /**
   * Build a URL from every facet form on the page, so the drawer and the
   * sidebar always agree.
   */
  function buildUrl() {
    var params = new URLSearchParams();
    var seen = {};

    document.querySelectorAll('[data-rc-facets]').forEach(function (form) {
      new FormData(form).forEach(function (value, key) {
        if (value === '' || value === null) return;
        var token = key + '=' + value;
        if (seen[token]) return;
        seen[token] = true;
        params.append(key, value);
      });
    });

    var base = window.location.pathname;
    var query = params.toString();
    return query ? base + '?' + query : base;
  }

  /* --------------------------------------------------------------- Events */

  // Filter change
  document.addEventListener('change', function (event) {
    var form = event.target.closest('[data-rc-facets]');
    if (!form) return;
    if (event.target.matches('[data-rc-sort-input]')) return;

    // Mirror the change into every other facet form so they stay in sync.
    var changed = event.target;
    if (changed.name && changed.type === 'checkbox') {
      document.querySelectorAll('[data-rc-facets]').forEach(function (other) {
        if (other === form) return;
        var twin = other.querySelector(
          'input[name="' + CSS.escape(changed.name) + '"][value="' + CSS.escape(changed.value) + '"]'
        );
        if (twin) twin.checked = changed.checked;
      });
    }

    renderFromUrl(buildUrl(), { scroll: false });
  });

  // Price inputs are debounced so typing doesn't fire a request per keystroke.
  var debouncedPrice = RC.debounce(function () {
    renderFromUrl(buildUrl(), { scroll: false });
  }, 600);

  document.addEventListener('input', function (event) {
    if (event.target.closest('[data-rc-facets]') && event.target.matches('[data-rc-price-min], [data-rc-price-max]')) {
      debouncedPrice();
    }
  });

  // Prevent a full page load on submit (noscript fallback still works).
  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-rc-facets]');
    if (!form) return;
    event.preventDefault();
    renderFromUrl(buildUrl());
  });

  // Remove a single active filter
  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-rc-facet-remove]');
    if (!link) return;
    event.preventDefault();
    renderFromUrl(link.href, { scroll: false });
  });

  // Sorting
  document.addEventListener('click', function (event) {
    var item = event.target.closest('[data-rc-sort-value]');
    if (!item) return;

    event.preventDefault();
    var value = item.dataset.rcSortValue;

    document.querySelectorAll('[data-rc-sort-input]').forEach(function (input) {
      input.value = value;
    });

    var label = document.querySelector('[data-rc-sort-label]');
    if (label) label.textContent = item.textContent.trim();

    renderFromUrl(buildUrl(), { scroll: false });
  });

  // Column switcher
  document.addEventListener('click', function (event) {
    var item = event.target.closest('[data-rc-layout-switch] .tf-view-layout-switch');
    if (!item) return;

    var layout = item.dataset.valueLayout;
    var grid = document.querySelector('[data-rc-grid]');
    if (!grid) return;

    grid.className = grid.className.replace(/tf-col-\d/g, '').trim() + ' ' + layout;

    item.parentElement.querySelectorAll('.tf-view-layout-switch').forEach(function (el) {
      el.classList.toggle('active', el === item);
    });

    RC.storage.set('rc:grid-layout', layout);
  });

  // Load more
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-rc-load-more]');
    if (!button) return;

    event.preventDefault();
    loadNext(button.dataset.nextUrl, button.closest('.rc-load-more'), button);
  });

  function loadNext(url, container, button) {
    if (!url) return;

    var root = section();
    if (!root) return;

    if (button) button.classList.add('rc-loading');

    RC.fetchText(url + (url.indexOf('?') === -1 ? '?' : '&') + 'section_id=' + root.dataset.sectionId)
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var freshGrid = doc.querySelector('[data-rc-grid]');
        var currentGrid = document.querySelector('[data-rc-grid]');

        if (freshGrid && currentGrid) {
          Array.prototype.slice.call(freshGrid.children).forEach(function (card) {
            currentGrid.appendChild(card);
          });
        }

        // Advance or remove the trigger.
        var freshTrigger = doc.querySelector('[data-rc-load-more], [data-rc-infinite]');
        if (freshTrigger && container) {
          var nextUrl = freshTrigger.dataset.nextUrl;
          var trigger = container.querySelector('[data-rc-load-more], [data-rc-infinite]') || container;
          if (nextUrl) {
            trigger.dataset.nextUrl = nextUrl;
          } else if (container.parentNode) {
            container.parentNode.removeChild(container);
          }
        } else if (container && container.parentNode) {
          container.parentNode.removeChild(container);
        }

        document.dispatchEvent(new CustomEvent('rc:collection:appended'));
      })
      .catch(function () {
        RC.toast(RC.strings.cartError, 'error');
      })
      .finally(function () {
        if (button) button.classList.remove('rc-loading');
      });
  }

  /* ----------------------------------------------------- Infinite scroll */

  var observer = null;

  function initInfinite() {
    var trigger = document.querySelector('[data-rc-infinite]');
    if (!trigger || !('IntersectionObserver' in window)) return;

    if (observer) observer.disconnect();

    observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          var url = el.dataset.nextUrl;
          if (!url || el.dataset.rcBusy) return;

          el.dataset.rcBusy = 'true';
          loadNext(url, el, null);

          window.setTimeout(function () {
            delete el.dataset.rcBusy;
            initInfinite();
          }, 600);
        });
      },
      { rootMargin: '400px' }
    );

    observer.observe(trigger);
  }

  document.addEventListener('rc:collection:appended', initInfinite);
  document.addEventListener('rc:collection:rendered', initInfinite);

  /* --------------------------------------------------------- Price slider */

  function initPriceSliders(scope) {
    if (typeof window.noUiSlider === 'undefined') return;

    scope.querySelectorAll('[data-rc-price-slider]').forEach(function (el) {
      if (el.noUiSlider) el.noUiSlider.destroy();

      var min = parseFloat(el.dataset.min) || 0;
      var max = parseFloat(el.dataset.max) || 100;
      if (max <= min) max = min + 1;

      var from = parseFloat(el.dataset.from);
      var to = parseFloat(el.dataset.to);
      if (isNaN(from)) from = min;
      if (isNaN(to)) to = max;

      var wrapper = el.closest('.rc-price-range');
      var minInput = wrapper ? wrapper.querySelector('[data-rc-price-min]') : null;
      var maxInput = wrapper ? wrapper.querySelector('[data-rc-price-max]') : null;

      window.noUiSlider.create(el, {
        start: [from, to],
        connect: true,
        step: 1,
        range: { min: min, max: max }
      });

      el.noUiSlider.on('update', function (values) {
        if (minInput) minInput.value = Math.round(values[0]);
        if (maxInput) maxInput.value = Math.round(values[1]);
      });

      el.noUiSlider.on('change', function () {
        renderFromUrl(buildUrl(), { scroll: false });
      });
    });
  }

  /* ----------------------------------------------------------------- Init */

  window.addEventListener('popstate', function () {
    if (section()) renderFromUrl(window.location.href, { skipHistory: true, scroll: false });
  });

  RC.onSectionLoad(function (scope) {
    var root = scope === document ? document : scope;
    initPriceSliders(root);
    initInfinite();

    // Restore the shopper's preferred column count.
    var saved = RC.storage.get('rc:grid-layout', null);
    var grid = root.querySelector ? root.querySelector('[data-rc-grid]') : null;
    if (saved && grid) {
      grid.className = grid.className.replace(/tf-col-\d/g, '').trim() + ' ' + saved;
      document.querySelectorAll('[data-rc-layout-switch] .tf-view-layout-switch').forEach(function (el) {
        el.classList.toggle('active', el.dataset.valueLayout === saved);
      });
    }
  });
})();
